import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Route, Redirect, Link, useLocation } from "react-router-dom";
import { Row, Col, Menu, Button, Modal, message, Carousel } from "antd";
import cookie from "react-cookies";
import "./index.less";
import {
  ExclamationCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import moment from "moment";
import qs from "qs";

const Home = (props) => {
  const {} = props;

  const contentStyle = {
    height: "460px",
    color: "#fff",
    lineHeight: "460px",
    textAlign: "center",
    background: "#364d79",
  };

  const onChange = (currentSlide) => {
    // console.log(currentSlide);
  };
  useEffect(() => {
    document.title = "七朵云 - 存储解决方案服务商";
  }, []);
  return (
    <div className="home context">
      <div className="carousel">
        <Carousel autoplay afterChange={onChange}>
          <div className="cover-img">
            <img
              src={require("../../../assets/image/banner/banner1.jpg").default}
              style={{ width: "100%" }}
            />
          </div>
          {/* <div className="cover-img">
            <img
              src={`https://qiduo-1251034078.cos.ap-shanghai.myqcloud.com/bananer/B1.png`}
              style={{ width: "100%" }}
            />
          </div>
          <div className="cover-img">
            <img
              src={`https://qiduo-1251034078.cos.ap-shanghai.myqcloud.com/bananer/B2.png`}
              style={{ width: "100%" }}
            />
          </div>
          <div className="cover-img">
            <img
              src={`https://qiduo-1251034078.cos.ap-shanghai.myqcloud.com/bananer/B3.png`}
              style={{ width: "100%" }}
            />
          </div> */}
        </Carousel>
      </div>
      <div className="container">
        <div className="download-list">
          <div className="download-list-item">
            <div className="title">U盘引导下载</div>
            <Button
              href="https://www.123pan.com/s/ChnUVv-p8653.html"
              target="_blank"
              icon={
                <img
                  src={require("../../../assets/image/download.png").default}
                />
              }
              type="primary"
            >
              x86 引导
            </Button>
            <div className="tip">更新时间：2024年1月16日</div>
          </div>
          <div className="download-list-item">
            <div className="title">x86 通用固件下载</div>
            <Button
              href="https://www.123pan.com/s/ChnUVv-f8653.html"
              target="_blank"
              icon={
                <img
                  src={require("../../../assets/image/download.png").default}
                />
              }
              type="primary"
            >
              点击下载
            </Button>
            <div className="tip">更新时间：2024年1月16日</div>
          </div>
          <div className="download-list-item">
            <div className="title">LoongArch 固件下载</div>
            <Button
              href="https://www.123pan.com/s/ChnUVv-a8653.html "
              target="_blank"
              icon={
                <img
                  src={require("../../../assets/image/download.png").default}
                />
              }
              type="primary"
            >
              即将开放
            </Button>
            <div className="tip">更新时间：2024年1月8日</div>
          </div>
          <div className="download-list-item">
            <div className="title">ARM 固件下载</div>
            <Button
              href="https://www.123pan.com/s/ChnUVv-B8653.html"
              target="_blank"
              icon={
                <img
                  src={require("../../../assets/image/download.png").default}
                />
              }
              type="primary"
            >
              即将开放
            </Button>
            <div className="tip">更新时间：2024年1月8日</div>
          </div>
          <div className="download-list-item">
            <div className="title">MINI5 固件下载</div>
            <Button
              href="https://www.123pan.com/s/ChnUVv-J8653.html"
              target="_blank"
              icon={
                <img
                  src={require("../../../assets/image/download.png").default}
                />
              }
              type="primary"
            >
              即将开放
            </Button>
            <div className="tip">更新时间：2024年1月8日</div>
          </div>
          <div className="download-list-item">
            <div className="title">N100 固件下载</div>
            <Button
              href="https://www.123pan.com/s/ChnUVv-I8653.html"
              target="_blank"
              icon={
                <img
                  src={require("../../../assets/image/download.png").default}
                />
              }
              type="primary"
            >
              即将开放
            </Button>
            <div className="tip">更新时间：2024年1月8日</div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="qrcodes">
          <div className="tips">
            <div className="title">帮助社区 & 讨论</div>
            <div className="subtitle">
              FSM 2.0 版本安装使用，升级指引。硬件适配讨论，官方合作硬件购买指南
            </div>
          </div>
          <div className="qrcode-list">
            <div className="qrcode-list-item">
              <img
                src={require("../../../assets/image/contact_me_qr.png").default}
              />
              <div className="txt">微信扫码加入群聊</div>
            </div>
            <div className="qrcode-list-item">
              <img
                src={require("../../../assets/image/qrcode-454.png").default}
              />
              <div className="txt">QQ扫码加入群聊</div>
            </div>
            <div className="qrcode-list-item">
              <img
                src={require("../../../assets/image/qrcode-dev.png").default}
              />
              <div className="txt">QQ扫码加入开发者</div>
            </div>
            <div className="qrcode-list-item">
              <img
                src={
                  require("../../../assets/image/1_1006984384_171_85_3_793848229_4f826da9db2e55bb6d0a7e847f4a08da.png")
                    .default
                }
              />
              <div className="txt">扫码看文档指引</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
